/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Addr_Wiz_NewInputs */

const cs_addr_wiz_new = /** @type {(inputs: Addr_Wiz_NewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} nových nabídek: návrhy budou k dispozici po importu na detailu nemovitosti.`)
};

const en_addr_wiz_new = /** @type {(inputs: Addr_Wiz_NewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} new offers: suggestions will be available on the property detail after import.`)
};

/**
* | output |
* | --- |
* | "{count} new offers: suggestions will be available on the property detail after import." |
*
* @param {Addr_Wiz_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_wiz_new = /** @type {((inputs: Addr_Wiz_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Wiz_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_wiz_new(inputs)
	return cs_addr_wiz_new(inputs)
});